import React, { FC, useCallback, useEffect, useState, useMemo, useRef } from 'react';
import styled from 'styled-components';
import { Avatar, Colors, CommonInput, FInter, FlexBox, Fonts, INPUT_TYPES, NavBavMobileSearchTabs } from '@brg/ui';
import { useTranslation } from 'react-i18next';
import { API, Designer, DesignerAPI, Endpoints, PageModel, Project, Team } from '@brg/api';
import { useHistory } from 'react-router-dom';
import { LayoutConst } from 'core';
import { computeProject } from 'shared/helpers/types/computed/ComputedProject';
import ResizedImageEnhanced from 'shared/components/ResizedImageEnhanced';
import { computeTeam } from 'shared/helpers/types/computed/ComputedTeam';
// import { ModalPagination } from "shared/components/pagination/modalPagination";
import { Pagination as ModalPagination } from '../../../../../../shared/components/pagination/pagination';
// import { ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { computeDesigner } from 'shared/helpers/computeData';
import { CreateLinkTo } from 'shared/constants/linkTo';
import { ItemComponent } from 'shared/apps/_team/app';

export enum ModerationType {
    'Default' = 0,
    'Hsedesign' = 1,
    'Own' = 2,
    'LMS' = 3,
    'OwnWithoutTag' = 4,
    'Standard' = 5,
    'StandardWithoutTag' = 6,
    'Channel' = 7,
    'ChannelGroupOrCourse' = 8,
}

export const SearchInput = styled.input<{ footer?: boolean }>`
    width: 100%;
    background-color: transparent;
    ${Fonts.Inter.smallText};
    color: ${(p) => p.theme.navigationBar.search.color};
    outline: none !important;
    border: none;
    transition: all 0.2s;
    height: ${({ footer }) => (footer ? 'auto' : '40')}px;
    padding: 0 35px 0 0;
    letter-spacing: -0.02em;

    &::placeholder {
        color: ${(p) => p.theme.mainSearchBar.placeholder.color};
        font-weight: 400;
        font-size: ${({ footer }) => (footer ? '11' : '17')}px;
        line-height: ${({ footer }) => (footer ? '13' : '22')}px;
    }

    @media (max-width: ${LayoutConst.screen.l_16}px) {
        &::placeholder {
            font-size: ${({ footer }) => (footer ? '11' : '15')}px;
            line-height: ${({ footer }) => (footer ? '13' : '20')}px;
        }

        font-size: ${({ footer }) => (footer ? '11px' : 'inherit')};
        line-height: ${({ footer }) => (footer ? '13px' : 'inherit')};
    }
    @media (max-width: ${LayoutConst.screen.m_1024}px) {
        font-size: ${({ footer }) => (footer ? '11px' : '17px')} !important;
        line-height: ${({ footer }) => (footer ? '13px' : '22px')} !important;
        &::placeholder {
            font-size: 13px;
            line-height: 18px;
        }
    }
`;

const SearchResultItem = styled(FInter.SmallTextDiv)`
    @media (max-width: ${LayoutConst.screen.m}px) {
        font-size: 17px;
        line-height: 22px;
    }
`;

export const SearchLine = styled(FlexBox)`
    background: ${(p) => p.theme.navigationBar.search.line};
    height: 2px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
`;

//todo remove static height

export const SearchWrapper = styled(FlexBox)<{ out?: boolean; footer?: boolean; mobile?: boolean }>`
    align-items: center;
    height: ${({ footer }) => (footer ? '24' : '40')}px !important;
    margin-left: ${({ footer }) => (footer ? '27.5' : '0')}px;
    position: relative;
    justify-content: flex-end;
    width: 320px;
    background-color: ${({ theme, footer, mobile }) =>
        mobile
            ? theme.navigationBar?.mobileMenu?.search?.bg
            : footer
            ? theme.mainSearchBarFooter.bg
            : theme.mainSearchBar.bg};
    border-radius: 3px;

    @media (max-width: ${LayoutConst.screen.l_16}px) {
        height: ${({ footer }) => (footer ? '24' : '36')}px !important;
        width: ${({ footer }) => (footer ? '270' : '260')}px !important;
    }

    @media (max-width: ${LayoutConst.screen.m_1024}px) {
        width: 100%;
        max-width: 592px;
        height: ${({ footer }) => (footer ? '24' : '32')}px !important;
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
        width: 364px;
        max-width: 364px;
        background-color: ${({ theme, footer }) =>
            footer ? theme.mainSearchBarFooter.bg : theme.navigationBar?.mobileMenu?.search?.bg};
    }
    @media (max-width: ${LayoutConst.screen.s}px) {
        // padding: 15px 10px 13px 10px !important;
    }
`;

export const SearchFlexBox = styled(FlexBox)<{ footer?: boolean }>`
    height: ${({ footer }) => (footer ? '24' : '64')}px !important;
    position: relative;
    align-items: center;
    color: ${(p) => p.theme.navigationBar.search.colorFlex};
    min-height: 100%;

    @media (max-width: ${LayoutConst.screen.l_16}px) {
        height: ${({ footer }) => (footer ? '24' : '48')}px !important;
    }

    @media (max-width: ${LayoutConst.screen.m_1024}px) {
        width: 100%;
    }
`;

export const NavbarSearchWrapper = styled.div<{ footer?: boolean }>`
    display: flex;
    cursor: pointer;
    // opacity: 0.47;
    transition: opacity 0.2s;
    align-items: center;
    position: relative;
    margin-right: 15px;
    margin-left: 20px;
    svg {
        * {
            fill: ${(p) => p.theme.navigationBar.search.svg} !important;
        }
    }
    &:hover {
        svg {
            * {
                fill: ${(p) => p.theme.navigationBar.search.svgHover} !important;
            }
        }
    }

    svg {
        width: ${({ footer }) => (footer ? '14' : '24')}px !important;
        height: ${({ footer }) => (footer ? '14' : '24')}px !important;
    }

    @media (max-width: ${LayoutConst.screen.l_16}px) {
        margin-right: ${({ footer }) => (footer ? '10' : '13')}px !important;
        margin-left: ${({ footer }) => (footer ? '12' : '16')}px !important;
        svg {
            width: ${({ footer }) => (footer ? '14' : '16')}px !important;
            height: ${({ footer }) => (footer ? '14' : '16')}px !important;
        }
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        margin-left: 0px !important;
        margin-right: 8px !important;
        // margin-top: 1px;
        input {
            max-width: 240px;
        }
    }
`;

export const NavbarResultsWrapper = styled.div<{ footer?: boolean }>`
    position: absolute;
    background-color: ${(p) => p.theme.app.backgroundColor};
    max-height: 200px;
    width: 320px;
    top: ${({ footer }) => (footer ? 'auto' : '40px')};
    bottom: ${({ footer }) => (footer ? '36px' : 'auto')};
    left: 0;
    overflow-y: auto;
    overflow-x: hidden;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.12);
    // border: 1px solid ${(p) => p.theme.app.ten};
    &::-webkit-scrollbar {
        width: 3px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: #909090;
    }
    @media (max-width: ${LayoutConst.screen.m}px) {
        max-height: 320px;
    }
    @media (max-width: ${LayoutConst.screen.s}px) {
        max-height: 200px;
    }
`;

export const NavbarResultsItem = styled.div`
    display: flex;
    width: 320px;
    height: 64px;
    //   border-bottom: 1px solid ${(p) => p.theme.app.ten};
    cursor: pointer;
    transition: background-color 0.2s;
    background-color: ${(p) => p.theme.app.backgroundColor};
    :hover {
        background-color: ${(p) => p.theme.app.ten};
    }
    :active {
        background-color: ${Colors.galBlack31};
    }

    //   @media(max-width: ${LayoutConst.screen.l_16}px) {
    //     width: 260px;
    //   }
`;

const ProjectImageWrapper = styled(ResizedImageEnhanced)`
    width: 100%;
    height: 100%;
    border-radius: 3px;
    overflow: hidden;
`;

export interface MainMenuSearchBarProps {
    onSearch?: (searchValue: string) => Promise<boolean>;
    isFooterItem?: boolean;
    mobile?: boolean;
    isMainMobileSearch?: boolean;
}

export const useDebouncedEffect = (effect: any, deps: any, delay: number) => {
    useEffect(() => {
        const handler = setTimeout(() => effect(), delay);

        return () => clearTimeout(handler);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [...(deps || []), delay]);
};

const TABS = {
    people: 'people',
    projects: 'projects',
    organizations: 'organizations',
    channels: 'channels',
};

export const NavbarSearchWidgetStatic: FC<MainMenuSearchBarProps> = ({ isFooterItem, mobile, isMainMobileSearch }) => {
    const [search, setSearch] = React.useState(true);
    const searchRef = React.useRef<HTMLInputElement>();
    const [isLoading, setIsLoading] = useState(false);
    const [designers, setDesigners] = useState<Designer[]>([]);
    const [projects, setProjects] = useState<Project[]>([]);
    const [teams, setTeams] = useState<Project[]>([]);
    const [channels, setChannels] = useState<Team[]>([]);
    const [currentPageProjects, setCurrentPageProjects] = useState(1);
    const [currentPageChannels, setCurrentPageChannels] = useState(1);
    const [pages, setPages] = useState(0);
    const [hasMoreProjects, setHasMoreProjects] = useState(false);
    const [hasMoreChannels, setHasMoreChannels] = useState(false);
    const INITIAL_TAB = 'people';
    const [currentTab, setCurrentTab] = useState(INITIAL_TAB);

    const [combineData, setCombineData] = useState<any[]>([]);
    const { i18n, t } = useTranslation();
    const history = useHistory();
    const [searchText, setSearchText] = useState('');
    const [isEmpty, setIsEmpty] = useState(false);
    const loaderRef = useRef<HTMLDivElement | null>(null);
    const scrollContainerRef = useRef<HTMLDivElement | null>(null);

    // console.log('loaderRef', loaderRef, 'currentTab', currentTab, 'hasMoreProjects', hasMoreProjects, 'hasMoreChannels', hasMoreChannels)

    const fetchProjects = async (pageToFetch: number) => {
        setIsLoading(true);
        const req = API.request()
            .endpoint(Endpoints.geograffee)
            .url('/api/project/AutoCompletePaging')
            .get()
            .addQuery('key', searchText)
            .addQuery('page', pageToFetch);

        const response = await req.send();
        const jsonData = await response.json();
        const data = API.toLang<PageModel<Project>>(jsonData, i18n.language);

        setProjects((prev) => {
            const newItems = data.data ?? [];
            if (pageToFetch === 1) return newItems;
            return [...prev, ...newItems];
        });
        setPages(data.paging?.pages);
        setHasMoreProjects(pageToFetch < data.paging?.pages);
        setIsEmpty((data.data?.length ?? 0) < 1 && pageToFetch === 1);
        setIsLoading(false);
    };

    const fetchDesigners = async () =>
        DesignerAPI.AutoComplete({
            key: searchText,
        })
            .then((v) => v.json())
            .then((v) => API.toLang<Designer[]>(v, i18n.language))
            .then((v) => {
                setDesigners(v);
                setIsEmpty(v.length < 1);
            });

    const fetchChannels = async (pageToFetch: number) => {
        setIsLoading(true);
        return API.request()
            .endpoint(Endpoints.geograffee)
            .url('/api/Team/GetChannelsAutoCompletePaging')
            .get()
            .addQuery('key', searchText)
            .addQuery('page', pageToFetch)
            .send()
            .then((v) => v.json())
            .then((v) => {
                setChannels((prev) => {
                    const newItems = API.toLang<Team[]>(v.data, i18n.language);
                    return pageToFetch === 1 ? newItems : [...prev, ...newItems];
                });

                setPages(v.paging?.pages);
                setHasMoreChannels(pageToFetch < v.paging?.pages);
                setIsEmpty((v.data?.length ?? 0) < 1 && pageToFetch === 1);
                setIsLoading(false);
                setCurrentTab(INITIAL_TAB)
            });
    };

    useDebouncedEffect(
        () => {
            if (searchText.length >= 2) {
                setCurrentPageProjects(1);
                setCurrentPageChannels(1);
                fetchProjects(1);
                fetchChannels(1);
                fetchDesigners();
            } else {

                setDesigners([]);
                setProjects([]);
                setChannels([]);

                setIsEmpty(false);
                setHasMoreProjects(false);
                setHasMoreChannels(false);
            }
        },
        [searchText, i18n.language],
        700,
    );

    useEffect(() => {
        //@ts-ignore
        setCombineData([...designers, ...(projects ?? []), ...(channels ?? [])]);
    }, [designers, projects, channels]);

    useEffect(() => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTop = 0;
        }
    }, [currentTab]);

    useEffect(() => {
        // console.log(loaderRef.current, isLoading, 'hasMoreChannels', hasMoreChannels, 'hasMoreProjects', hasMoreProjects)

        if (!loaderRef.current) return;
        const observer = new IntersectionObserver(
            (entries) => {
                const entry = entries[0];
                if (entry.isIntersecting && (hasMoreChannels || hasMoreProjects) && !isLoading) {
                    if (entry.isIntersecting && (hasMoreChannels || hasMoreProjects) && !isLoading) {
                        if (currentTab === TABS.channels && hasMoreChannels) {
                            const nextPage = currentPageChannels + 1;
                            setCurrentPageChannels(nextPage);
                            fetchChannels(nextPage);
                        } else if (currentTab === TABS.projects && hasMoreProjects) {
                            const nextPage = currentPageProjects + 1;
                            setCurrentPageProjects(nextPage);
                            fetchProjects(nextPage);
                        }
                    }
                }
            },
            {
                root: scrollContainerRef.current,
                threshold: 0.1,
            },
        );

        observer.observe(loaderRef.current);

        return () => {
            observer.disconnect();
        };
    }, [hasMoreChannels, hasMoreProjects, isLoading, currentTab, currentPageProjects, currentPageChannels]);

    const onSearchResultItemClick = useCallback(
        (item: any, isProject?: boolean, isChannel?: boolean) => {
            const path =
                item?.moderationType === ModerationType.Channel
                    ? process.env.REACT_APP_URL_MEDIIIA_COM + CreateLinkTo.team(item?.teamId)
                    : isProject
                    ? process.env.REACT_APP_URL_MEDIIIA_COM + CreateLinkTo.projectNew(item)
                    : process.env.REACT_APP_URL_MEDIIIA_COM + CreateLinkTo.designerNew(item);

            window.open(path);

            resetSearchMode();
        },
        [history],
    );

    const resetSearchMode = useCallback(() => {
        setSearchText('');
        setSearch(true);
        if (searchRef.current) {
            searchRef.current.value = '';
        }
        setCombineData([]);
    }, []);

    const resultItems = useMemo(() => {
        return [...combineData].map((item) => {
            const cv = computeDesigner(item, { showFullName: true });
            const project = computeProject(item);
            const team = computeTeam(item);
            //@ts-ignore
            const isProject = !!item?.projectId;
            //@ts-ignore
            const isTeam = !!item?.teamId;
            return {
                //@ts-ignore
                onClick: () => onSearchResultItemClick(isProject ? project : isTeam ? team : cv, isProject),
                avatarCV: cv,
                name: cv?.fullName || '',
                title: project?.title || '',
                //@ts-ignore
                titleImages: item?.titleImages || ([] as unknown),
                projectId: project?.projectId || '',
                projectType: project?.projectType,
                designerId: cv?.designerId || '',
                isProject: isProject,
                isTeam: isTeam,
            };
        });
    }, [combineData, onSearchResultItemClick]);

    const showClose = useMemo(() => !!searchText?.length, [searchText]);

    // console.log('combineData', combineData, 'hasMoreChannels', hasMoreChannels, 'hasMoreProjects', hasMoreProjects, 'currentPageChannels', currentPageChannels, 'currentPageProjects', currentPageProjects)

    if (isMainMobileSearch) {
        return (
            <NavBavMobileSearchTabs
                resultsData={[...combineData].map((item) => {
                    const cv = computeDesigner(item, { showFullName: true });
                    const project = computeProject(item);
                    const team = computeTeam(item);
                    const channel = computeTeam(item);
                    //@ts-ignore
                    const isProject = !!item?.projectId;
                    //@ts-ignore
                    const isTeam = !!item?.teamId && item.moderationType !== ModerationType.Channel;
                    //@ts-ignore
                    const isChannels = item && item.moderationType === ModerationType.Channel;

                    return {
                        onClick: () =>
                            onSearchResultItemClick(
                                isProject ? project : isTeam ? team : isChannels ? channel : cv,
                                isProject,
                                isChannels,
                            ),
                        avatarCV: { ...cv, backColor: '#CDCDCD' },
                        name: cv?.fullName || '',
                        title: project?.title || '',
                        //@ts-ignore
                        titleImages: item?.titleImages || ([] as unknown),
                        projectId: project?.projectId || '',
                        projectType: project?.projectType,
                        designerId: cv?.designerId || '',
                        isProject: isProject,
                        isTeam: isTeam,
                        isChannels: isChannels,
                        isBlurred: Boolean(item.isAgeRestricted),
                        id: item.projectId || item.designerId || item.teamId,
                    };
                })}
                searchText={searchText}
                setSearchText={setSearchText}
                isEmpty={isEmpty}
                Endpoints={Endpoints}
                isLoading={isLoading}
                pages={pages}
                placeholder={t('new_search_common')}
                minTextLength={2}
                orientation={'left'}
                // onClose={() => false}
                onClose={() => false}
                autoOpen={true}
                texts={{
                    needMoreChars: t('text.more2chars'),
                    loading: t('text.loading'),
                    notFound: t('text.notfound'),
                    newSearch: t('new_search_common'),
                    hintTooltip: t('hints.search'),
                    tabs: {
                        people: t('main_search.tabs.people'),
                        projects: t('main_search.tabs.projects'),
                        channels: t('main_search.tabs.channels'),
                    },
                }}
                lastElementRef={loaderRef}
                scrollContainerRef={scrollContainerRef}
                currentTab={currentTab}
                setCurrentTab={setCurrentTab}
                // modalPaginationComponent={
                //   <ModalPagination
                //     height={50}
                //     pages={pages}
                //     page={currentPage}
                //     onPageChange={(page) => {
                //       setCurrentPage(page);
                //     }}
                //   />
                // }
                modalPaginationComponent={<></>}
            />
        );
    }

    return (
        <SearchFlexBox
            footer={isFooterItem}
            className={`main-searchbar-wrapper ${isFooterItem && 'main-searchbar-wrapper__vertical'}`}
        >
            <SearchWrapper footer={isFooterItem} className="main-searchbar-input-wrapper" mobile={mobile}>
                {search && (
                    <>
                        <CommonInput
                            type={INPUT_TYPES.search}
                            value={searchText}
                            ref={searchRef as any}
                            placeholder={t('new_search_common')}
                            onChange={(e: any) => setSearchText(e.target.value?.trim())}
                        />
                    </>
                )}

                {searchText.length > 0 && search ? (
                    <NavbarResultsWrapper footer={isFooterItem} className={'main-searchbar-results-wrapper'}>
                        {resultItems.map((v) => {
                            const orientation = v.isProject
                                ? ['fixed-ratio-small', 't-shape', 'fixed-ratio-large']?.includes(v.projectType)
                                    ? 'horizontal'
                                    : 'vertical'
                                : undefined;
                            const isHorizontal = orientation === 'horizontal';

                            return (
                                <NavbarResultsItem
                                    className={'main-searchbar_item'}
                                    onClick={v.onClick}
                                    key={v.isProject ? v.projectId : v.designerId}
                                >
                                    <FlexBox align={'center'} gx={8}>
                                        <FlexBox
                                            style={{ padding: '4px' }}
                                            width={isHorizontal ? 110 : 64}
                                            height={isHorizontal ? 'auto' : 64}
                                        >
                                            {v.isProject ? (
                                                <ProjectImageWrapper files={v.titleImages} />
                                            ) : (
                                                <Avatar {...v.avatarCV} />
                                            )}
                                        </FlexBox>
                                        <SearchResultItem>{v.isProject ? v.title : v.name}</SearchResultItem>
                                    </FlexBox>
                                </NavbarResultsItem>
                            );
                        })}
                        {resultItems.length < 1 && searchText.length < 2 && (
                            <NavbarResultsItem className={'main-searchbar_item'}>
                                <FlexBox align={'center'} width={'100%'} justify={'center'} gx={8}>
                                    <FInter.SmallTextDiv>{t('text.more2chars')}</FInter.SmallTextDiv>
                                </FlexBox>
                            </NavbarResultsItem>
                        )}
                        {resultItems.length < 1 && searchText.length >= 2 && !isEmpty && (
                            <NavbarResultsItem className={'main-searchbar_item'}>
                                <FlexBox align={'center'} width={'100%'} justify={'center'} gx={8}>
                                    <FInter.SmallTextDiv>{t('text.loading')}</FInter.SmallTextDiv>
                                </FlexBox>
                            </NavbarResultsItem>
                        )}
                        {resultItems.length < 1 && searchText.length >= 2 && isEmpty && (
                            <NavbarResultsItem className={'main-searchbar_item'}>
                                <FlexBox align={'center'} width={'100%'} justify={'center'} gx={8}>
                                    <FInter.SmallTextDiv>{t('text.notfound')}</FInter.SmallTextDiv>
                                </FlexBox>
                            </NavbarResultsItem>
                        )}
                    </NavbarResultsWrapper>
                ) : null}
            </SearchWrapper>
        </SearchFlexBox>
    );
};import React, { FC, useCallback, useEffect, useState, useMemo, useRef } from 'react';
import styled from 'styled-components';
import { Avatar, Colors, CommonInput, FInter, FlexBox, Fonts, INPUT_TYPES, NavBavMobileSearchTabs } from '@brg/ui';
import { useTranslation } from 'react-i18next';
import { API, Designer, DesignerAPI, Endpoints, PageModel, Project, Team } from '@brg/api';
import { useHistory } from 'react-router-dom';
import { LayoutConst } from 'core';
import { computeProject } from 'shared/helpers/types/computed/ComputedProject';
import ResizedImageEnhanced from 'shared/components/ResizedImageEnhanced';
import { computeTeam } from 'shared/helpers/types/computed/ComputedTeam';
// import { ModalPagination } from "shared/components/pagination/modalPagination";
import { Pagination as ModalPagination } from '../../../../../../shared/components/pagination/pagination';
// import { ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { computeDesigner } from 'shared/helpers/computeData';
import { CreateLinkTo } from 'shared/constants/linkTo';
import { ItemComponent } from 'shared/apps/_team/app';

export enum ModerationType {
    'Default' = 0,
    'Hsedesign' = 1,
    'Own' = 2,
    'LMS' = 3,
    'OwnWithoutTag' = 4,
    'Standard' = 5,
    'StandardWithoutTag' = 6,
    'Channel' = 7,
    'ChannelGroupOrCourse' = 8,
}

export const SearchInput = styled.input<{ footer?: boolean }>`
    width: 100%;
    background-color: transparent;
    ${Fonts.Inter.smallText};
    color: ${(p) => p.theme.navigationBar.search.color};
    outline: none !important;
    border: none;
    transition: all 0.2s;
    height: ${({ footer }) => (footer ? 'auto' : '40')}px;
    padding: 0 35px 0 0;
    letter-spacing: -0.02em;

    &::placeholder {
        color: ${(p) => p.theme.mainSearchBar.placeholder.color};
        font-weight: 400;
        font-size: ${({ footer }) => (footer ? '11' : '17')}px;
        line-height: ${({ footer }) => (footer ? '13' : '22')}px;
    }

    @media (max-width: ${LayoutConst.screen.l_16}px) {
        &::placeholder {
            font-size: ${({ footer }) => (footer ? '11' : '15')}px;
            line-height: ${({ footer }) => (footer ? '13' : '20')}px;
        }

        font-size: ${({ footer }) => (footer ? '11px' : 'inherit')};
        line-height: ${({ footer }) => (footer ? '13px' : 'inherit')};
    }
    @media (max-width: ${LayoutConst.screen.m_1024}px) {
        font-size: ${({ footer }) => (footer ? '11px' : '17px')} !important;
        line-height: ${({ footer }) => (footer ? '13px' : '22px')} !important;
        &::placeholder {
            font-size: 13px;
            line-height: 18px;
        }
    }
`;

const SearchResultItem = styled(FInter.SmallTextDiv)`
    @media (max-width: ${LayoutConst.screen.m}px) {
        font-size: 17px;
        line-height: 22px;
    }
`;

export const SearchLine = styled(FlexBox)`
    background: ${(p) => p.theme.navigationBar.search.line};
    height: 2px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
`;

//todo remove static height

export const SearchWrapper = styled(FlexBox)<{ out?: boolean; footer?: boolean; mobile?: boolean }>`
    align-items: center;
    height: ${({ footer }) => (footer ? '24' : '40')}px !important;
    margin-left: ${({ footer }) => (footer ? '27.5' : '0')}px;
    position: relative;
    justify-content: flex-end;
    width: 320px;
    background-color: ${({ theme, footer, mobile }) =>
        mobile
            ? theme.navigationBar?.mobileMenu?.search?.bg
            : footer
            ? theme.mainSearchBarFooter.bg
            : theme.mainSearchBar.bg};
    border-radius: 3px;

    @media (max-width: ${LayoutConst.screen.l_16}px) {
        height: ${({ footer }) => (footer ? '24' : '36')}px !important;
        width: ${({ footer }) => (footer ? '270' : '260')}px !important;
    }

    @media (max-width: ${LayoutConst.screen.m_1024}px) {
        width: 100%;
        max-width: 592px;
        height: ${({ footer }) => (footer ? '24' : '32')}px !important;
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
        width: 364px;
        max-width: 364px;
        background-color: ${({ theme, footer }) =>
            footer ? theme.mainSearchBarFooter.bg : theme.navigationBar?.mobileMenu?.search?.bg};
    }
    @media (max-width: ${LayoutConst.screen.s}px) {
        // padding: 15px 10px 13px 10px !important;
    }
`;

export const SearchFlexBox = styled(FlexBox)<{ footer?: boolean }>`
    height: ${({ footer }) => (footer ? '24' : '64')}px !important;
    position: relative;
    align-items: center;
    color: ${(p) => p.theme.navigationBar.search.colorFlex};
    min-height: 100%;

    @media (max-width: ${LayoutConst.screen.l_16}px) {
        height: ${({ footer }) => (footer ? '24' : '48')}px !important;
    }

    @media (max-width: ${LayoutConst.screen.m_1024}px) {
        width: 100%;
    }
`;

export const NavbarSearchWrapper = styled.div<{ footer?: boolean }>`
    display: flex;
    cursor: pointer;
    // opacity: 0.47;
    transition: opacity 0.2s;
    align-items: center;
    position: relative;
    margin-right: 15px;
    margin-left: 20px;
    svg {
        * {
            fill: ${(p) => p.theme.navigationBar.search.svg} !important;
        }
    }
    &:hover {
        svg {
            * {
                fill: ${(p) => p.theme.navigationBar.search.svgHover} !important;
            }
        }
    }

    svg {
        width: ${({ footer }) => (footer ? '14' : '24')}px !important;
        height: ${({ footer }) => (footer ? '14' : '24')}px !important;
    }

    @media (max-width: ${LayoutConst.screen.l_16}px) {
        margin-right: ${({ footer }) => (footer ? '10' : '13')}px !important;
        margin-left: ${({ footer }) => (footer ? '12' : '16')}px !important;
        svg {
            width: ${({ footer }) => (footer ? '14' : '16')}px !important;
            height: ${({ footer }) => (footer ? '14' : '16')}px !important;
        }
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        margin-left: 0px !important;
        margin-right: 8px !important;
        // margin-top: 1px;
        input {
            max-width: 240px;
        }
    }
`;

export const NavbarResultsWrapper = styled.div<{ footer?: boolean }>`
    position: absolute;
    background-color: ${(p) => p.theme.app.backgroundColor};
    max-height: 200px;
    width: 320px;
    top: ${({ footer }) => (footer ? 'auto' : '40px')};
    bottom: ${({ footer }) => (footer ? '36px' : 'auto')};
    left: 0;
    overflow-y: auto;
    overflow-x: hidden;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.12);
    // border: 1px solid ${(p) => p.theme.app.ten};
    &::-webkit-scrollbar {
        width: 3px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: #909090;
    }
    @media (max-width: ${LayoutConst.screen.m}px) {
        max-height: 320px;
    }
    @media (max-width: ${LayoutConst.screen.s}px) {
        max-height: 200px;
    }
`;

export const NavbarResultsItem = styled.div`
    display: flex;
    width: 320px;
    height: 64px;
    //   border-bottom: 1px solid ${(p) => p.theme.app.ten};
    cursor: pointer;
    transition: background-color 0.2s;
    background-color: ${(p) => p.theme.app.backgroundColor};
    :hover {
        background-color: ${(p) => p.theme.app.ten};
    }
    :active {
        background-color: ${Colors.galBlack31};
    }

    //   @media(max-width: ${LayoutConst.screen.l_16}px) {
    //     width: 260px;
    //   }
`;

const ProjectImageWrapper = styled(ResizedImageEnhanced)`
    width: 100%;
    height: 100%;
    border-radius: 3px;
    overflow: hidden;
`;

export interface MainMenuSearchBarProps {
    onSearch?: (searchValue: string) => Promise<boolean>;
    isFooterItem?: boolean;
    mobile?: boolean;
    isMainMobileSearch?: boolean;
}

export const useDebouncedEffect = (effect: any, deps: any, delay: number) => {
    useEffect(() => {
        const handler = setTimeout(() => effect(), delay);

        return () => clearTimeout(handler);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [...(deps || []), delay]);
};

const TABS = {
    people: 'people',
    projects: 'projects',
    organizations: 'organizations',
    channels: 'channels',
};

export const NavbarSearchWidgetStatic: FC<MainMenuSearchBarProps> = ({ isFooterItem, mobile, isMainMobileSearch }) => {
    const [search, setSearch] = React.useState(true);
    const searchRef = React.useRef<HTMLInputElement>();
    const [isLoading, setIsLoading] = useState(false);
    const [designers, setDesigners] = useState<Designer[]>([]);
    const [projects, setProjects] = useState<Project[]>([]);
    const [teams, setTeams] = useState<Project[]>([]);
    const [channels, setChannels] = useState<Team[]>([]);
    const [currentPageProjects, setCurrentPageProjects] = useState(1);
    const [currentPageChannels, setCurrentPageChannels] = useState(1);
    const [pages, setPages] = useState(0);
    const [hasMoreProjects, setHasMoreProjects] = useState(false);
    const [hasMoreChannels, setHasMoreChannels] = useState(false);
    const INITIAL_TAB = 'people';
    const [currentTab, setCurrentTab] = useState(INITIAL_TAB);

    const [combineData, setCombineData] = useState<any[]>([]);
    const { i18n, t } = useTranslation();
    const history = useHistory();
    const [searchText, setSearchText] = useState('');
    const [isEmpty, setIsEmpty] = useState(false);
    const loaderRef = useRef<HTMLDivElement | null>(null);
    const scrollContainerRef = useRef<HTMLDivElement | null>(null);

    // console.log('loaderRef', loaderRef, 'currentTab', currentTab, 'hasMoreProjects', hasMoreProjects, 'hasMoreChannels', hasMoreChannels)

    const fetchProjects = async (pageToFetch: number) => {
        setIsLoading(true);
        const req = API.request()
            .endpoint(Endpoints.geograffee)
            .url('/api/project/AutoCompletePaging')
            .get()
            .addQuery('key', searchText)
            .addQuery('page', pageToFetch);

        const response = await req.send();
        const jsonData = await response.json();
        const data = API.toLang<PageModel<Project>>(jsonData, i18n.language);

        setProjects((prev) => {
            const newItems = data.data ?? [];
            if (pageToFetch === 1) return newItems;
            return [...prev, ...newItems];
        });
        setPages(data.paging?.pages);
        setHasMoreProjects(pageToFetch < data.paging?.pages);
        setIsEmpty((data.data?.length ?? 0) < 1 && pageToFetch === 1);
        setIsLoading(false);
    };

    const fetchDesigners = async () =>
        DesignerAPI.AutoComplete({
            key: searchText,
        })
            .then((v) => v.json())
            .then((v) => API.toLang<Designer[]>(v, i18n.language))
            .then((v) => {
                setDesigners(v);
                setIsEmpty(v.length < 1);
            });

    const fetchChannels = async (pageToFetch: number) => {
        setIsLoading(true);
        return API.request()
            .endpoint(Endpoints.geograffee)
            .url('/api/Team/GetChannelsAutoCompletePaging')
            .get()
            .addQuery('key', searchText)
            .addQuery('page', pageToFetch)
            .send()
            .then((v) => v.json())
            .then((v) => {
                setChannels((prev) => {
                    const newItems = API.toLang<Team[]>(v.data, i18n.language);
                    return pageToFetch === 1 ? newItems : [...prev, ...newItems];
                });

                setPages(v.paging?.pages);
                setHasMoreChannels(pageToFetch < v.paging?.pages);
                setIsEmpty((v.data?.length ?? 0) < 1 && pageToFetch === 1);
                setIsLoading(false);
                setCurrentTab(INITIAL_TAB)
            });
    };

    useDebouncedEffect(
        () => {
            if (searchText.length >= 2) {
                setCurrentPageProjects(1);
                setCurrentPageChannels(1);
                fetchProjects(1);
                fetchChannels(1);
                fetchDesigners();
            } else {

                setDesigners([]);
                setProjects([]);
                setChannels([]);

                setIsEmpty(false);
                setHasMoreProjects(false);
                setHasMoreChannels(false);
            }
        },
        [searchText, i18n.language],
        700,
    );

    useEffect(() => {
        //@ts-ignore
        setCombineData([...designers, ...(projects ?? []), ...(channels ?? [])]);
    }, [designers, projects, channels]);

    useEffect(() => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTop = 0;
        }
    }, [currentTab]);

    useEffect(() => {
        // console.log(loaderRef.current, isLoading, 'hasMoreChannels', hasMoreChannels, 'hasMoreProjects', hasMoreProjects)

        if (!loaderRef.current) return;
        const observer = new IntersectionObserver(
            (entries) => {
                const entry = entries[0];
                if (entry.isIntersecting && (hasMoreChannels || hasMoreProjects) && !isLoading) {
                    if (entry.isIntersecting && (hasMoreChannels || hasMoreProjects) && !isLoading) {
                        if (currentTab === TABS.channels && hasMoreChannels) {
                            const nextPage = currentPageChannels + 1;
                            setCurrentPageChannels(nextPage);
                            fetchChannels(nextPage);
                        } else if (currentTab === TABS.projects && hasMoreProjects) {
                            const nextPage = currentPageProjects + 1;
                            setCurrentPageProjects(nextPage);
                            fetchProjects(nextPage);
                        }
                    }
                }
            },
            {
                root: scrollContainerRef.current,
                threshold: 0.1,
            },
        );

        observer.observe(loaderRef.current);

        return () => {
            observer.disconnect();
        };
    }, [hasMoreChannels, hasMoreProjects, isLoading, currentTab, currentPageProjects, currentPageChannels]);

    const onSearchResultItemClick = useCallback(
        (item: any, isProject?: boolean, isChannel?: boolean) => {
            const path =
                item?.moderationType === ModerationType.Channel
                    ? process.env.REACT_APP_URL_MEDIIIA_COM + CreateLinkTo.team(item?.teamId)
                    : isProject
                    ? process.env.REACT_APP_URL_MEDIIIA_COM + CreateLinkTo.projectNew(item)
                    : process.env.REACT_APP_URL_MEDIIIA_COM + CreateLinkTo.designerNew(item);

            window.open(path);

            resetSearchMode();
        },
        [history],
    );

    const resetSearchMode = useCallback(() => {
        setSearchText('');
        setSearch(true);
        if (searchRef.current) {
            searchRef.current.value = '';
        }
        setCombineData([]);
    }, []);

    const resultItems = useMemo(() => {
        return [...combineData].map((item) => {
            const cv = computeDesigner(item, { showFullName: true });
            const project = computeProject(item);
            const team = computeTeam(item);
            //@ts-ignore
            const isProject = !!item?.projectId;
            //@ts-ignore
            const isTeam = !!item?.teamId;
            return {
                //@ts-ignore
                onClick: () => onSearchResultItemClick(isProject ? project : isTeam ? team : cv, isProject),
                avatarCV: cv,
                name: cv?.fullName || '',
                title: project?.title || '',
                //@ts-ignore
                titleImages: item?.titleImages || ([] as unknown),
                projectId: project?.projectId || '',
                projectType: project?.projectType,
                designerId: cv?.designerId || '',
                isProject: isProject,
                isTeam: isTeam,
            };
        });
    }, [combineData, onSearchResultItemClick]);

    const showClose = useMemo(() => !!searchText?.length, [searchText]);

    // console.log('combineData', combineData, 'hasMoreChannels', hasMoreChannels, 'hasMoreProjects', hasMoreProjects, 'currentPageChannels', currentPageChannels, 'currentPageProjects', currentPageProjects)

    if (isMainMobileSearch) {
        return (
            <NavBavMobileSearchTabs
                resultsData={[...combineData].map((item) => {
                    const cv = computeDesigner(item, { showFullName: true });
                    const project = computeProject(item);
                    const team = computeTeam(item);
                    const channel = computeTeam(item);
                    //@ts-ignore
                    const isProject = !!item?.projectId;
                    //@ts-ignore
                    const isTeam = !!item?.teamId && item.moderationType !== ModerationType.Channel;
                    //@ts-ignore
                    const isChannels = item && item.moderationType === ModerationType.Channel;

                    return {
                        onClick: () =>
                            onSearchResultItemClick(
                                isProject ? project : isTeam ? team : isChannels ? channel : cv,
                                isProject,
                                isChannels,
                            ),
                        avatarCV: { ...cv, backColor: '#CDCDCD' },
                        name: cv?.fullName || '',
                        title: project?.title || '',
                        //@ts-ignore
                        titleImages: item?.titleImages || ([] as unknown),
                        projectId: project?.projectId || '',
                        projectType: project?.projectType,
                        designerId: cv?.designerId || '',
                        isProject: isProject,
                        isTeam: isTeam,
                        isChannels: isChannels,
                        isBlurred: Boolean(item.isAgeRestricted),
                        id: item.projectId || item.designerId || item.teamId,
                    };
                })}
                searchText={searchText}
                setSearchText={setSearchText}
                isEmpty={isEmpty}
                Endpoints={Endpoints}
                isLoading={isLoading}
                pages={pages}
                placeholder={t('new_search_common')}
                minTextLength={2}
                orientation={'left'}
                // onClose={() => false}
                onClose={() => false}
                autoOpen={true}
                texts={{
                    needMoreChars: t('text.more2chars'),
                    loading: t('text.loading'),
                    notFound: t('text.notfound'),
                    newSearch: t('new_search_common'),
                    hintTooltip: t('hints.search'),
                    tabs: {
                        people: t('main_search.tabs.people'),
                        projects: t('main_search.tabs.projects'),
                        channels: t('main_search.tabs.channels'),
                    },
                }}
                lastElementRef={loaderRef}
                scrollContainerRef={scrollContainerRef}
                currentTab={currentTab}
                setCurrentTab={setCurrentTab}
                // modalPaginationComponent={
                //   <ModalPagination
                //     height={50}
                //     pages={pages}
                //     page={currentPage}
                //     onPageChange={(page) => {
                //       setCurrentPage(page);
                //     }}
                //   />
                // }
                modalPaginationComponent={<></>}
            />
        );
    }

    return (
        <SearchFlexBox
            footer={isFooterItem}
            className={`main-searchbar-wrapper ${isFooterItem && 'main-searchbar-wrapper__vertical'}`}
        >
            <SearchWrapper footer={isFooterItem} className="main-searchbar-input-wrapper" mobile={mobile}>
                {search && (
                    <>
                        <CommonInput
                            type={INPUT_TYPES.search}
                            value={searchText}
                            ref={searchRef as any}
                            placeholder={t('new_search_common')}
                            onChange={(e: any) => setSearchText(e.target.value?.trim())}
                        />
                    </>
                )}

                {searchText.length > 0 && search ? (
                    <NavbarResultsWrapper footer={isFooterItem} className={'main-searchbar-results-wrapper'}>
                        {resultItems.map((v) => {
                            const orientation = v.isProject
                                ? ['fixed-ratio-small', 't-shape', 'fixed-ratio-large']?.includes(v.projectType)
                                    ? 'horizontal'
                                    : 'vertical'
                                : undefined;
                            const isHorizontal = orientation === 'horizontal';

                            return (
                                <NavbarResultsItem
                                    className={'main-searchbar_item'}
                                    onClick={v.onClick}
                                    key={v.isProject ? v.projectId : v.designerId}
                                >
                                    <FlexBox align={'center'} gx={8}>
                                        <FlexBox
                                            style={{ padding: '4px' }}
                                            width={isHorizontal ? 110 : 64}
                                            height={isHorizontal ? 'auto' : 64}
                                        >
                                            {v.isProject ? (
                                                <ProjectImageWrapper files={v.titleImages} />
                                            ) : (
                                                <Avatar {...v.avatarCV} />
                                            )}
                                        </FlexBox>
                                        <SearchResultItem>{v.isProject ? v.title : v.name}</SearchResultItem>
                                    </FlexBox>
                                </NavbarResultsItem>
                            );
                        })}
                        {resultItems.length < 1 && searchText.length < 2 && (
                            <NavbarResultsItem className={'main-searchbar_item'}>
                                <FlexBox align={'center'} width={'100%'} justify={'center'} gx={8}>
                                    <FInter.SmallTextDiv>{t('text.more2chars')}</FInter.SmallTextDiv>
                                </FlexBox>
                            </NavbarResultsItem>
                        )}
                        {resultItems.length < 1 && searchText.length >= 2 && !isEmpty && (
                            <NavbarResultsItem className={'main-searchbar_item'}>
                                <FlexBox align={'center'} width={'100%'} justify={'center'} gx={8}>
                                    <FInter.SmallTextDiv>{t('text.loading')}</FInter.SmallTextDiv>
                                </FlexBox>
                            </NavbarResultsItem>
                        )}
                        {resultItems.length < 1 && searchText.length >= 2 && isEmpty && (
                            <NavbarResultsItem className={'main-searchbar_item'}>
                                <FlexBox align={'center'} width={'100%'} justify={'center'} gx={8}>
                                    <FInter.SmallTextDiv>{t('text.notfound')}</FInter.SmallTextDiv>
                                </FlexBox>
                            </NavbarResultsItem>
                        )}
                    </NavbarResultsWrapper>
                ) : null}
            </SearchWrapper>
        </SearchFlexBox>
    );
};